import React from 'react'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import { Button } from 'reactstrap'
import ExportHeadcountForm from '../form/export-headcount'
import { FONTS, COLORS } from '../../../constants'

export default class SearchBarHeadcount extends React.Component {
  state={
    showExport: false,
    selectedStartMonth: moment(),
    selectedEndMonth: moment(),
    selectedLOB: '',
  }

  handleInputExport = (type, e) => {
    switch (type) {
      case 'startDate': {
        this.setState({ selectedStartMonth: e })
        break
      }
      case 'endDate': {
        this.setState({ selectedEndMonth: e })
        break
      }
      case 'lob': {
        this.setState({ selectedLOB: e })
        break
      }
      default: break
    }
  }

  clickExportButton = (type) => {
    switch (type) {
      case 'export': {
        const exportHeadcount = get(this.props, 'exportHeadcount')
        const { selectedLOB, selectedStartMonth, selectedEndMonth } = this.state
        exportHeadcount(
          get(selectedLOB, 'lob_id'),
          moment(selectedStartMonth, 'MM/YY').format('YYYY-MM'),
          moment(selectedEndMonth, 'MM/YY').format('YYYY-MM'))
        break
      }
      default: break
    }
    this.setState({
      showExport: !this.state.showExport,
      selectedStartMonth: moment(),
      selectedEndMonth: moment(),
      selectedLOB: '',
    })
  }

  render() {
    const lobList = get(this.props, 'lobList', [])
    return (
      <Wrapper>
        <ExportHeadcountForm
          open={ this.state.showExport }
          lobList={ lobList }
          selectedStartMonth={ this.state.selectedStartMonth }
          selectedEndMonth={ this.state.selectedEndMonth }
          selectedLOB={ this.state.selectedLOB }
          handleInputExport={ this.handleInputExport }
          clickExportButton={ this.clickExportButton }
        />
        <TextWrapper>
          <Text style={ { fontFamily: FONTS.GOTHAM_MEDIUM } }>Reports as of Today</Text>
          <Text> · ({moment().format('DD/MM/YYYY')})</Text>
        </TextWrapper>
        <ExportButton
          bg={ COLORS.UPLOAD_COLOR }
          border={ COLORS.UPLOAD_COLOR_BORDER }
          onClick={ () => this.setState({ showExport: !this.state.showExport }) }
        >
          Export
        </ExportButton>
      </Wrapper>
    )
  }
}

const TextWrapper = styled.div`
  display: flex;
`
const Text = styled.span`
  font-size: ${FONTS.SMALL_SIZE};
`
const ExportButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  font-family: ${FONTS.GOTHAM};
  background-color: #ffffff;  
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
`




// WEBPACK FOOTER //
// ./src/components/report/search-bar/headcount.js